import { render, staticRenderFns } from "./SyncClassAdvisors.vue?vue&type=template&id=f0f25eb6"
import script from "./SyncClassAdvisors.vue?vue&type=script&lang=js"
export * from "./SyncClassAdvisors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports